import React from 'react';
import styled from 'styled-components';

import { Flex } from 'Components/Base';

const DetailContainer = styled((props) => <Flex {...props} />)`
  max-height: 230px;
  flex-shrink: 1;
  overflow-y: auto;
`;

export default DetailContainer;
